import { __rest, __assign } from '../../../../_virtual/_tslib.js';
import React from 'react';
import { TextTypes, LinkText } from '@citygross/typography';
import { LinkAsButton, IconWrapper, BaseLink } from './Link.styles.js';
var LinkSize;

(function (LinkSize) {
  LinkSize[LinkSize["small"] = 0] = "small";
  LinkSize[LinkSize["medium"] = 1] = "medium";
})(LinkSize || (LinkSize = {}));

var LinkColors;

(function (LinkColors) {
  LinkColors[LinkColors["link"] = 0] = "link";
  LinkColors[LinkColors["black"] = 1] = "black";
})(LinkColors || (LinkColors = {}));

var ELinkVariant;

(function (ELinkVariant) {
  ELinkVariant["PRIMARY"] = "primary";
  ELinkVariant["SECONDARY"] = "secondary";
  ELinkVariant["TERTIARY"] = "tertiary";
})(ELinkVariant || (ELinkVariant = {}));

function Link(_a) {
  var isDisabled = _a.isDisabled,
      noWrap = _a.noWrap,
      onClick = _a.onClick,
      hrefPath = _a.hrefPath,
      icon = _a.icon,
      _b = _a.size,
      size = _b === void 0 ? TextTypes.TextSize.REGULAR : _b,
      _c = _a.target,
      target = _c === void 0 ? '_self' : _c,
      borderRadius = _a.borderRadius,
      _d = _a.tabIndex,
      tabIndex = _d === void 0 ? 0 : _d,
      _e = _a.inverted,
      inverted = _e === void 0 ? false : _e,
      children = _a.children,
      asButton = _a.asButton,
      _f = _a.variant,
      variant = _f === void 0 ? ELinkVariant.PRIMARY : _f,
      props = __rest(_a, ["isDisabled", "noWrap", "onClick", "hrefPath", "icon", "size", "target", "borderRadius", "tabIndex", "inverted", "children", "asButton", "variant"]);

  return asButton ? React.createElement(LinkAsButton, __assign({
    tabIndex: isDisabled ? -1 : tabIndex,
    isDisabled: isDisabled,
    noWrap: noWrap,
    variant: variant,
    onClick: onClick,
    onKeyDown: function onKeyDown(event) {
      if (event.key === 'Enter') {
        onClick && onClick();
      }
    },
    size: size,
    icon: icon,
    borderRadius: borderRadius,
    inverted: inverted
  }, props), React.createElement(LinkText, {
    size: size
  }, children), icon && React.createElement(IconWrapper, null, icon)) : React.createElement(BaseLink, __assign({
    tabIndex: isDisabled ? -1 : tabIndex,
    href: hrefPath,
    isDisabled: isDisabled,
    variant: variant,
    noWrap: noWrap,
    onClick: onClick,
    onKeyDown: function onKeyDown(event) {
      if (event.key === 'Enter') {
        onClick && onClick();
      }
    },
    size: size,
    icon: icon,
    borderRadius: borderRadius,
    inverted: inverted,
    target: target
  }, props), React.createElement(LinkText, {
    size: size
  }, children), icon && React.createElement(IconWrapper, null, icon));
}

export { ELinkVariant, Link, LinkColors, LinkSize };